var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('confirm-dialog',{attrs:{"show":_vm.show,"message":_vm.message},on:{"accept":_vm.updateStatus,"close":function($event){_vm.$emit('close')}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c0f621f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WhatsappTemplates/UpdateStatusWhatsappTemplateDialog.vue
// module id = null
// module chunks = 